function get(endpoint) {
    return (accessToken) => {
        return fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {  
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
    }
}

function post(endpoint) {
    return (accessToken, body) => {
        return fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {  
            method: 'POST',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    };
}

const API = {
    getActiveEvents(accessToken) {
        var options = {  
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }
        if (accessToken !== undefined) {
            options.withCredentials = true;
            options.credentials = 'include';
            options.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return fetch(`${process.env.REACT_APP_API_URL}/active-events`, options);
    },

    getActiveEvent(accessToken, eventId) {
        return fetch(`${process.env.REACT_APP_API_URL}/active-events/${eventId}`, {  
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
    },
    adminUpdateServerInfo(accessToken, room) {
        return fetch(`${process.env.REACT_APP_API_URL}/admin/server-info/${room.room_id}`, {  
            method: 'POST',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                'server_ip': room.server_ip,
                'server_port': room.server_port,
                'artist_url': room.artist_url,
                'video_url': room.video_url
            })
        });
    },

    deleteWallet(accessToken, address) {
        return fetch(`${process.env.REACT_APP_API_URL}/multi/user/settings/wallets/${address}`, {  
            method: 'DELETE',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
    },
    customizeCharacter: post("/customize-character"),
    getWallets: get("/multi/user/settings/wallets"),
    addWallet: post("/multi/user/settings/wallets"),
    getFuturebotAssets: get("/futurebot-assets"),
    updateUsername: post("/update-username"),
    getAvailableServers: get("/available-servers"),
    joinServer: post("/join-server"),
    addEthWallet: post("/multi/user/settings/wallets/eth"),
    leaveServer: post("/leave-server"),
    addNiftyWallet: post("/multi/user/settings/wallets/nifty"),
    getDigitalShops: get("/digital-shops"),
    postPurchaseItem: post("/purchase-item"),
    getDeeplink: get("/deeplink-info"),
    postPasswordEntry: post("/password-entry"),

    adminGetServerInfos: get("/admin/server-info"),
    adminGetEvents: get("/admin/events"),
    adminUpdateEvent: post("/admin/events"),
}

export default API;
